import { Pipe, PipeTransform } from '@angular/core';
import { TrackingInfo } from '../models/tracking-info.model';

@Pipe({
  name: 'naverTrackingUrl',
})
export class NaverTrackingUrlPipe implements PipeTransform {
  transform(value: TrackingInfo): string {
    return `https://search.naver.com/search.naver?query=${encodeURIComponent(
      value.company_name
    )}+${encodeURIComponent(value.invoice_no)}`;
  }
}
